var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "55", height: "54", viewBox: "0 0 55 54", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M27 0c14.912 0 27 12.088 27 27S41.912 54 27 54 0 41.912 0 27 12.088 0 27 0z", id: "path-123" })
    ),
    React.createElement(
      "g",
      { transform: "translate(.5)", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "mask-2", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#path-123" })
      ),
      React.createElement("use", { fill: "#5181B8", fillRule: "nonzero", xlinkHref: "#path-123" }),
      React.createElement(
        "g",
        { mask: "url(#mask-2)", fill: "#FFF", fillRule: "nonzero" },
        React.createElement("path", { d: "M36.065 29.213c-.47-.595-.335-.86 0-1.391.006-.007 3.876-5.38 4.275-7.204h.002c.199-.665 0-1.153-.958-1.153h-3.17c-.808 0-1.18.419-1.38.887 0 0-1.614 3.884-3.898 6.401-.737.727-1.077.96-1.48.96-.198 0-.506-.233-.506-.897v-6.199c0-.796-.226-1.152-.894-1.152H23.07c-.506 0-.807.371-.807.717 0 .756 1.142.93 1.26 3.054v4.611c0 1.01-.182 1.196-.587 1.196-1.078 0-3.694-3.899-5.245-8.361-.313-.866-.618-1.216-1.431-1.216h-3.172c-.906 0-1.088.419-1.088.888 0 .828 1.078 4.945 5.012 10.385 2.623 3.714 6.315 5.726 9.675 5.726 2.019 0 2.265-.447 2.265-1.216 0-3.548-.182-3.883.83-3.883.468 0 1.275.233 3.16 2.024 2.155 2.124 2.509 3.075 3.715 3.075h3.17c.905 0 1.363-.447 1.1-1.329-.604-1.854-4.679-5.668-4.862-5.923z" })
      )
    )
  );
});